import {
    GETWITHDRAWLIMITLIST_SUCCESS,
    GETWITHDRAWLIMITLIST_FAILED,
    RESET_GETWITHDRAWLIMITLIST,
    LOADING_GETWITHDRAWLIMITLIST,
    NETWORK_ERROR_GETWITHDRAWLIMITLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWITHDRAWLIMITLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETWITHDRAWLIMITLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETWITHDRAWLIMITLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETWITHDRAWLIMITLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETWITHDRAWLIMITLIST:
            return (state = initialState);
        default:
            return state;
    }
};
